import apiRequest from "./apiClient";

export async function fetchUsers({ page = 0, size = 10, role, search } = {}) {
  const params = new URLSearchParams({ page, size });
  if (role) params.set("role", role);
  if (search) params.set("search", search);
  const body = await apiRequest(`/api/v1/admin/users?${params}`);
  return body.data;
}

export async function fetchUserById(userId) {
  const body = await apiRequest(`/api/v1/admin/users/${userId}`);
  return body.data;
}

export async function fetchBuyers() {
  return fetchUsers({ role: "BUYER", size: 100 });
}

export async function toggleUserStatus(userId) {
  await apiRequest(`/api/v1/admin/users/${userId}/status`, { method: "PUT" });
}

export async function verifyUser(userId) {
  await apiRequest(`/api/v1/admin/users/${userId}/verify`, { method: "PUT" });
}

export async function changeUserRole(userId, newRole) {
  await apiRequest(
    `/api/v1/admin/users/${userId}/role?newRole=${newRole}`,
    { method: "PUT" }
  );
}

export async function updateUserCapabilities(userId, { sellerEnabled, buyerEnabled }) {
  const body = await apiRequest(`/api/v1/admin/users/${userId}/capabilities`, {
    method: "PUT",
    body: JSON.stringify({ sellerEnabled, buyerEnabled }),
  });
  return body.data;
}

export async function processAccountDeletion(userId) {
  const body = await apiRequest(`/api/v1/admin/users/${userId}/process-deletion`, {
    method: "POST",
  });
  return body.data;
}

export async function approveVendor(userId) {
  const body = await apiRequest(`/api/v1/admin/users/${userId}/vendor/approve`, {
    method: "PUT",
  });
  return body.data;
}

export async function rejectVendor(userId) {
  const body = await apiRequest(`/api/v1/admin/users/${userId}/vendor/reject`, {
    method: "PUT",
  });
  return body.data;
}
